import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col, Spinner } from 'react-bootstrap';
import * as Icon from 'react-feather';

const MediaPicker = ({ show, onHide, onSelect, type = 'videos' }) => {
    const [library, setLibrary] = useState([]);
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);

    const fetchLibrary = async (pageNum = 1, isNewSearch = false) => {
        setLoading(true);
        try {
            const response = await fetch(`https://api.schedpilot.com/wp-json/api/v1/getMediaLibrary?type=${type}&search=${search}&page=${pageNum}`, {
                credentials: 'include'
            });
            const json = await response.json();
            if (json.code === 200) {
                setLibrary(prev => isNewSearch ? json.data : [...prev, ...json.data]);
            }
        } catch (err) {
            console.error("Error fetching library", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { if (show) fetchLibrary(1, true); }, [show, type]);

    const handleSearch = (e) => {
        e.preventDefault();
        setPage(1);
        fetchLibrary(1, true);
    };

    return (
        <Modal show={show} onHide={onHide} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title>Select {type === 'videos' ? 'Video' : 'Image'} from Library</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSearch} className="mb-3 d-flex">
                    <Form.Control 
                        type="text" 
                        placeholder="Search media..." 
                        value={search} 
                        onChange={(e) => setSearch(e.target.value)}
                    />
                    <Button type="submit" variant="primary" className="ms-2"><Icon.Search size={18}/></Button>
                </Form>

                <div style={{ maxHeight: '400px', overflowY: 'auto', overflowX: 'hidden' }}>
                    <Row className="g-2">
                        {library.map((item) => (
                            <Col xs={4} md={3} key={item.id}>
                                <div 
                                    className="position-relative border rounded overflow-hidden" 
                                    style={{ cursor: 'pointer', aspectRatio: '1/1', backgroundColor: '#000' }}
                                    onClick={() => onSelect(item)}
                                >
                                    {type === 'videos' ? (
                                        <video src={item.file_url} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                    ) : (
                                        <img src={item.file_url} style={{ width: '100%', height: '100%', objectFit: 'cover' }} alt="media" />
                                    )}
                                    <div className="position-absolute bottom-0 end-0 p-1">
                                        <Icon.PlusCircle className="text-white bg-primary rounded-circle" size={20} />
                                    </div>
                                </div>
                            </Col>
                        ))}
                    </Row>
                    {loading && <div className="text-center p-3"><Spinner animation="border" size="sm" /></div>}
                    {!loading && library.length > 0 && (
                        <Button variant="link" className="w-100 mt-2" onClick={() => { setPage(p => p + 1); fetchLibrary(page + 1); }}>
                            Load More
                        </Button>
                    )}
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default MediaPicker;